import React, { Component } from 'react'
import { StyleSheet, View, FlatList, ScrollView, Platform,Dimensions } from 'react-native'
import {
	JDText, JDTouchable, JDImage, JDJumping,
	JDDevice, JDShare, JDToast, JDModal, JDTouchableWithoutFeedback
} from '@jdreact/jdreact-core-lib'
import PropTypes from 'prop-types'
import appStyles from '../../App.style'
import constants from '../../constants'

import { getClueFloatingLayer, insertUserClueWithValidMsg, insertUserClue, getZufangDetailData } from '../../utils/api'

import ImgSwiper from './components/imgSwiper/ImgSwiper'
import BigImgSwiper from "./components/imgSwiper/BigImgSwiper"
import SubTitle from "./components/SubTitle"
import HouseDesItem from "./components/HouseDesItem"
import BrokerItem from "./components/BrokerItem"
import LiuZiCompon from "./components/LiuZiCompon"
import LoupanCard from "./components/LoupanCard"
import JDCNavigationBar from '../../components/JDCNavigationBar';

import { zufangCall } from "../../utils/callPhone";
import { pt, isJDApp, isWX, isWQ, sendClickDataWithJsonParam, sendPv } from '../../components/utiles';
import { imgProcess, isPhoneX, toDongDong, jumpingToWeb, isHarmonyWeb, harmonyWebShare, isJDAppWebView } from "../../utils/tools";
import { NAVIGATION_BAR_HEIGHT, SYS_BAR_HEIGHT } from '../../utils/steep';
import {
  detailTips,
	tipsArrow,
  shopIcon,
	BigShopImage
} from '../../utils/image'

import shareWhite from '../../images/shareWhi.png'
import shareBlack from '../../images/shareBlack.png'
import errpageImg from '../../images/detail/errpage.png'
import houseBg from '../../images/detail/house-bg.png'
import liuziIcon from '../../images/detail/yhch.png'
import skeletonImg from '../../images/detail/skeleton.png'


const tipsList=[{text:'价格包含哪些费用？'},{text:'价格还能优惠吗？'},{text:'配套设施如何？'},{text:'容积率是多少？'},{text:'停车位有多少？'},{text:'停车怎么收费？'}]
const brokerInfo={name:'专属经理',con:'本房源专属服务顾问，熟悉本房特色',headImg:'https://img13.360buyimg.com/imagetools/jfs/t1/151176/12/4774/5478/5f9a6836Eeb117fb1/53533ea25653216e.png',}
const isWeb = Platform.OS === 'web';
const justLiulanqiHead = isWeb ? ((isJDApp || isWX || isWQ) ? 0 : JDDevice.getRpx(88)) : NAVIGATION_BAR_HEIGHT + SYS_BAR_HEIGHT

const Page_Id = 'OfficeBuilding_HouseDetail'


// VR 跳转链接基础安全校验：防 CRLF 注入、反斜杠混淆、userinfo 伪装及伪协议
const isVrUrlSafe = (vrUrl) => {
	if (!vrUrl || typeof vrUrl !== 'string') {
		return false;
	}
	let decoded = vrUrl;
	try {
		decoded = decodeURIComponent(vrUrl);
	} catch (e) {
		// 解码失败时按原始字符串继续校验
	}
	// 对原始与解码后的字符串同时校验，防止 %2f%2f 等编码绕过
	const urls = [vrUrl, decoded];
	for (let i = 0; i < urls.length; i++) {
		const url = urls[i];
		// 1. 拒绝 CRLF/空字节/反斜杠/制表符（浏览器会把 \ 当作 / 处理）
		if (/[\r\n\t\0\\]/.test(url)) {
			return false;
		}
		// 2. 拒绝协议相对 URL（如 //evil.com）与 /\\ 混淆
		if (url.indexOf('//') === 0 || url.indexOf('/\\') === 0) {
			return false;
		}
		// 3. 拒绝含 userinfo 的 URL（如 http://attacker@legitimate.com）
		if (url.indexOf('@') !== -1) {
			return false;
		}
		// 4. 协议锁定：仅允许 http/https，拦截 javascript:/openapp: 等伪协议
		if (!/^https?:\/\//i.test(url)) {
			return false;
		}
	}
	return true;
};
class zufangDetail extends Component {
	static contextTypes = {
		router: PropTypes.object
	};
	constructor(props) {
		super(props);

		this.state = {
			telPhone: '',
			extentionPhone: '',
			introduction: '',
			HouseType: 'SELL', // 默认是出售房源
			skuId: this.props.skuId || "",
			cityId: '',
			cityName: '',
			venderId: '',
			shopId: '',
			isShowImgPreView: false,
			currentImgPage: 1,
			houseResourceDTO: {}, // 房源数据
			commerceBuildingDTO: {}, // 楼盘信息
			imgSwiperData: [],
			showVR: true,//单张图时是否展示VR
			playUrl: '', // 视频播放链接
			surfacePlot: '', //视频封面地址
			isLoading: false,	// 是否正在请求数据
			isShowErrMsg: false, // 是否展示错误信息
			errMsg: "", // 提示的错误信息
			isErrPage: false,
			isErrorSkuId: false,
			navBarOpacity: 0,
			showLiuziBox: false,
			liuziInfo: {
				imgUrl: '',
				advContent: '为了向您提供更精准的咨询服务，您所填写的信息将会同步传递给商家，该商家将尽快与您联系',
				advName: '优惠提醒'
			}

		};
		this.swiperRef = null;
		this.currentTabIndex = 0;
		this.titleView = null;
		// 楼层所在的scrollView
		this._scrollView = null;
		this.scrollViewHeight = 0;
		this.scrollViewContentHeight = 0;
		this.detailsPageScrollView = React.createRef();
		this.navBar = React.createRef();
	}
	componentDidMount() {
		this.queryDetailHouseResource();
		this.getLiuziInfo()
	}
	componentDidUpdate(prevProps, prevState) {
		if (prevProps.skuId !== this.props.skuId) {
			this.queryDetailHouseResource();
			this.getLiuziInfo()
			setTimeout(() => {
				// 处理 null is not an object 报错问题，可能的原因是在元素加载之前，就尝试在 JavaScript 中使用 DOM 元素
				this.detailsPageScrollView && this.detailsPageScrollView.current && this.detailsPageScrollView.current.scrollTo({ x: 0, y: 0, animated: true });
			}, 0);
		}
	}

	getLiuziInfo = () => {
		getClueFloatingLayer({id: 146}).then((res) => {
				const { code, data, success } = res
				if (success && data) {
					this.setState({
						liuziInfo: {
							imgUrl: data.imgUrl || '',
							advContent: data.advContent || '为了向您提供更精准的咨询服务，您所填写的信息将会同步传递给商家，该商家将尽快与您联系',
							advName: data.advName || '优惠提醒'
						}
					})
				} else {
					this.setState({
						liuziInfo: {
							imgUrl:'',
							advContent: '为了向您提供更精准的咨询服务，您所填写的信息将会同步传递给商家，该商家将尽快与您联系',
							advName: '优惠提醒'
						}
					})
				}
			})
			.catch((err) => {
				this.setState({
					liuziInfo: {
						imgUrl:'',
						advContent: '为了向您提供更精准的咨询服务，您所填写的信息将会同步传递给商家，该商家将尽快与您联系',
						advName: '优惠提醒'
					}
				})
			});
	}

	/**
 * @description 处理页面滚动逻辑
 * @memberof Index
 */
	handleTopOnScroll = ({
		nativeEvent: {
			contentOffset: { x, y },
			layoutMeasurement: { height: layoutHeight, width: layoutWidth },
			contentSize: { height, width }
		},
	}) => {
		// 横向滚动，也会触发该事件，要特殊处理一下
		if (isWeb && x > 0) return;
		if (!isWeb) {
			let opacity = (y >= NAVIGATION_BAR_HEIGHT) ? 1 : (Math.floor((y / NAVIGATION_BAR_HEIGHT) * 10) / 10);
			this.navBar && this.navBar.current && this.navBar.current.setBgOpacity(opacity);
			this.setState({
				navBarOpacity: opacity,
			})
		}

	}

	changeState = (item) => {
		this.setState({
			...item
		});
	}
	// 获取房源详情
	queryDetailHouseResource = () => {
		let skuId = this.props.skuId || '';
		if (!skuId) return
		this.setState({
			isLoading:true
		})
		sendPv({ pageId: Page_Id, pageParam: ''+skuId });

		getZufangDetailData({skuId:skuId}).then((res) => {
			const {code, data} = res
			if (code === 0 && data) {
						if (this.state.isErrPage) {
							this.setState({
								isErrPage: false
							});
						}
						if (this.state.isErrorSkuId) {
							this.setState({
								isErrorSkuId: false
							});
						}
						if (data.houseType) {
							const HouseType = data.houseType === 1 ? 'SELL' : (data.houseType === 2 ? 'RENT' : '')
							const houseResourceDTO = HouseType === 'SELL' ? (data.commerceTradeHouseDetail || {}) : HouseType === 'RENT' ? (data.commerceRentHouseDetail || {}) : {};
							const commerceBuildingDTO = data.commerceBuildingDTO || {}
							const { cityId, cityName, venderId, shopId} = commerceBuildingDTO
							const { videoUrl, videoImage, vrUrl, houseImage } = houseResourceDTO
							let imgDomainIndex = skuId % 7;
							let imgSwiperData = [];
							imgSwiperData = houseImage && houseImage.imageList.map((item) => {
								return imgProcess(item.imageUrl, "600x600", 70, imgDomainIndex || 1, 'esf', '!cc_67x50')
							});

							let surfacePlot = videoImage || imgSwiperData[0];
							// 有视频房源时
							if (videoUrl) {
								// 封面图，不传封面图用第一张主图替代
								if (!!vrUrl) {
									if (imgSwiperData.length < 2) {
										if (imgSwiperData[0]) {
											imgSwiperData.push(imgSwiperData[0])
										}
									}
									imgSwiperData.splice(1, 0, surfacePlot)
								} else {
									imgSwiperData.splice(0, 0, surfacePlot)
								}
							}
							this.setState({
								shopId,
								cityId,
								cityName,
								venderId,
								surfacePlot,
								HouseType,
								houseResourceDTO,
								commerceBuildingDTO,
								extentionPhone: houseResourceDTO.extentionPhone || '',
								telPhone: houseResourceDTO.telephone || '',
								introduction: houseResourceDTO.introduction || '',
								imgSwiperData: imgSwiperData,
								playUrl: videoUrl, // 视频地址
							}, () => {
								// 获取到数据后web端需要初始化分享内容
								if (Platform.OS === 'web') {
									const { title, url, shareImg, content } = this.getShareContent()
									if (isJDAppWebView() && typeof JdShare !== 'undefined' && !isHarmonyWeb()) {
										JdShare.setShareInfo({
											title, url, shareImg, content,
											img: shareImg,
											channel: '',
											callback: null,
											clickcallback: null,
											qrparam: null,
											timeline_title: '',
										})
									}
									if (isHarmonyWeb()) {
										harmonyWebShare({
											title, url, shareImg, content
										})
									}
									document.title = title
								}
							})
						}
			} else if(res.code == 10003){
				this.setState({
					isErrorSkuId: true
				});
			} else {
				this.setState({
					isErrPage: true
				});
			}
			// 解决ios端的h5页面偶尔不能滚动到顶部的问题
			if (Platform.OS === "web") {
				let u = navigator.userAgent, app = navigator.appVersion;
				let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
				if (isIOS) {
					setTimeout(() => {
						this.detailsPageScrollView.current.scrollTo({ x: 0, y: 0, animated: true });
					}, 0)
				}

			}
		}).catch(err => {
			this.setState({
				isErrPage: true
			});
		}).finally (()=>{
			this.setState({
				isLoading:false
			})
		})
	};

	// 渲染房源描述数据
	renderHouseDesItem = () => {
		let introduction = this.state.introduction;
		let cityId = this.state.cityId;
		return (<HouseDesItem introduction={introduction} cityId={cityId}></HouseDesItem>)
	};

	// 轮播图打开大图预览
	enterImgPreview = (currentIndex) => {
		let {
			vrUrl,
		} = this.state.houseResourceDTO || {};
		let { showVR, skuId, imgSwiperData } = this.state;
		if (currentIndex === 0 && vrUrl && showVR && isVrUrlSafe(vrUrl)) {
			sendClickDataWithJsonParam({
				event_id: 'OfficeBuilding_HouseDetail_VR',
				page_id: Page_Id,
				json_param: {
					skuid: skuId + '',
					vr_url: vrUrl
				},
			})

			JDJumping.jumpToWeb(vrUrl).catch(err => {
				console.log('跳转VR链接失败: ', err)
			})
		} else {
			sendClickDataWithJsonParam({
				event_id: 'OfficeBuilding_HouseDetail_Picture',
				page_id: Page_Id,
				json_param: {
					skuid: skuId + '',
					picture_sort: currentIndex + '',
					picurl: imgSwiperData[currentIndex]
				},
			})
			this.setState({
				isShowImgPreView: true,
				currentImgPage: currentIndex
			});
		}
		
	};
	// 轮播图关闭大图预览
	quitImgPreview = () => {
		this.setState({
			isShowImgPreView: false
		});
	};
	// 获取分享的数据
	getShareContent = () => {
		const { skuId } = this.props
		let { houseResourceDTO = {}, HouseType } = this.state
		const { countyName, streetName } = this.state.commerceBuildingDTO || {}
		let {
			title,
			totalPrice,
			totalType,
			houseImage = {}
		} = houseResourceDTO
		const img = (houseImage.imageList && houseImage.imageList[0] && houseImage.imageList[0].imageUrl ) ? houseImage.imageList[0].imageUrl : ''
		const imgUrl = img ? `https://img1.360buyimg.com/n4/${img}` : ''
		const totalTypeMy = totalType === 1 ? '元/月' : (totalType === 2 ? '元/年' : '')
		const danwei = HouseType === 'SELL'? '万元': totalTypeMy
		const content = countyName + (streetName ? streetName : '') + totalPrice + danwei
		return {
			title: title,
			url: `${constants.esfrUrl}zufangDetail?skuId=${skuId}`,
			shareImg: imgUrl,
			content: content,
		}
	}
	callPhone= () => { // 拨打底部的电话咨询
		sendClickDataWithJsonParam({
			event_id: 'OfficeBuilding_HouseDetail_DedicatedConsultant',
      page_id: Page_Id,
			json_param: {
				skuid: this.state.skuId + ''
			},
		})
		zufangCall(this.state.extentionPhone, this.state.telPhone);
	};
	callPhoneFooter= () => { // 拨打底部的电话咨询
		sendClickDataWithJsonParam({
			event_id: 'OfficeBuilding_HouseDetail_TeleConsult',
      page_id: Page_Id,
			json_param: {
				skuid: this.state.skuId + '',
				venderid: this.state.venderId + ''
			},
		})
		zufangCall(this.state.extentionPhone, this.state.telPhone);
	};
	goLineClick= () => { 
		const { skuId, venderId } = this.state
		const { title, shareImg } = this.getShareContent()

		sendClickDataWithJsonParam({
			event_id: 'OfficeBuilding_HouseDetail_OnlineConsult',
      page_id: Page_Id,
			json_param: {
				skuid: skuId + '',
				venderid: venderId + ''
			},
		})

		const obj = {
			skuId: skuId,
			name: title,
			imgUrl: shareImg,
			price: '--',
			venderId: venderId
		}
		toDongDong(obj)
	};
	goShopClick= () => {
		const { shopId, venderId, skuId } = this.state
		sendClickDataWithJsonParam({
			event_id: 'OfficeBuilding_HouseDetail_Shop',
      page_id: Page_Id,
			json_param: {
				skuid: skuId + '',
				venderid: venderId + ''
			},
		})

		const jumpUrl = `https://shop.m.jd.com/shop/home?shopId=${shopId}&venderId=${venderId}`
		jumpingToWeb(jumpUrl)
	};
	_onHide = () => { // 隐藏错误提示
		this.setState({
			errMsg: null,
			isShowErrMsg: false
		});
	};

	showErrFunc = (msg) => {
		this.setState({
			errMsg: msg,
			isShowErrMsg: true
		}, ()=> setTimeout(()=>{
			this._onHide()
		},3000))
	}
	// 点击优惠提醒
	handleLiuziIcon = () =>{
		const { venderId, skuId} = this.state
		this.setState({showLiuziBox: true})
		sendClickDataWithJsonParam({
			event_id: 'OfficeBuilding_HouseDetail_Subscribe',
      page_id: Page_Id,
			json_param: {
				skuid: skuId + '',
				venderid: venderId + ''
			},
		})
		
	}
	liuziConfirm = (obj) => {
		const { title } = this.state.houseResourceDTO || {}
		const { spuId, cityName } = this.state.commerceBuildingDTO || {}
		let paramsObj = {
			...obj,
			skuId: this.props.skuId,
			venderId: this.state.venderId,
			spuName: title,
			spuId: '',
			type: 4, // 活动留资5-不校验重复留资，优惠是4-校验重复留资
			clueCityName:cityName,	// 城市名称
		}

		sendClickDataWithJsonParam({
			event_id: 'OfficeBuilding_HouseDetail_SubscribeConfirm',
      page_id: Page_Id,
			json_param: {
				skuid: this.state.skuId + '',
				venderid: this.state.venderId + ''
			},
		})

		if (paramsObj && paramsObj.validMsg) {
			insertUserClueWithValidMsg(paramsObj).then((res) => {
					const { code, data, msg } = res
					let msagess = '当前活动太火爆啦！请稍后重试！'
					if (code === '1' || code === '120001') {
						msagess = code === '1' ? '订阅成功' : '您已添加提醒,无需重复添加'
						this.showErrFunc(msagess)
						this.setState({showLiuziBox: false})
					} else {
						msagess = msg || '当前活动太火爆啦！请稍后重试！'
						this.showErrFunc(msagess)
					}
					
				})
				.catch((err) => {
					this.showErrFunc('当前活动太火爆啦！请稍后重试！')
				});
		} else {
			insertUserClue(paramsObj).then((res) => {
					const { code, data, msg } = res
					let msagess = '当前活动太火爆啦！请稍后重试！'
					if (code === '1' || code === '120001') {
						msagess = code === '1' ? '订阅成功' : '您已添加提醒,无需重复操作'
						this.showErrFunc(msagess)
						this.setState({showLiuziBox: false})
					} else {
						msagess = msg || '当前活动太火爆啦！请稍后重试！'
						this.showErrFunc(msagess)
					}
					
				})
				.catch((err) => {
					this.showErrFunc('当前活动太火爆啦！请稍后重试！')
				});
		}

	}

	render() {
		let {
			telPhone,
			extentionPhone,
			introduction,
			HouseType,
			imgSwiperData,
			isShowImgPreView,
			skuId,
			showVR,
			playUrl,  //视频信息
			surfacePlot, //封面图
			isErrPage,
			isErrorSkuId,
			navBarOpacity,
			showLiuziBox,
			houseResourceDTO,
			liuziInfo,
			isLoading,
			commerceBuildingDTO,
			venderId,
		} = this.state;
		let {
			vrUrl,
			title,
			unitPrice,
			totalPrice,
			unitType,
			totalType,
			roomArea,
			orientations,
			renovation,
			level,
			floorType,
			registrable,
			separable,
			separableType,
			visitType,
			propertyOwner,
			buildingName,
			addressDetail,
			rentType,
			rentTimeType,
			pledgeMonth,
			payMonth,
			freePeriod,
			freeType,
			rentProperties,
		} = houseResourceDTO || {};

		let titleName = title;
		titleName ? (titleName = titleName.slice(0, 11) + '...') : (titleName = "房源详情");

		const isNavBarDarkStyle = isWeb || navBarOpacity > 0.8;

		const unitTypeMy = unitType === 1 ? '元/m²/天' : (unitType === 2 ? '元/m²/月' : (unitType === 5 ? '元/工位/月' : ''))
		const totalTypeMy = totalType === 1 ? '月租金（元/月）' : (totalType === 2 ? '年租金（元/年）' : '')
		
		return (
			<View style={styles.page}>
				<JDCNavigationBar
					renderMiddle={() => <View style={styles.navMiddBox}>
						<JDText style={styles.navMiddText}>{isNavBarDarkStyle ? titleName : ''}</JDText>
						<View style={styles.navShareView}>
							<JDTouchable style={styles.shareIconBox} key="shareIcon"
								onPress={() => {
									const { title, url, shareImg, content } = this.getShareContent()
									JDShare.showShareDialog(url, title, content, shareImg)
								}}
							><JDImage source={isNavBarDarkStyle ? shareBlack : shareWhite} style={styles.shareIcon} />
							</JDTouchable>
						</View>
					</View>}
					showMoreButton={true}
					containerStyle={{}}
					barContainerStyle={{ backgroundColor: 'transparent' }}
					bgStyle={{}}
					ref={this.navBar}
					theme={isNavBarDarkStyle ? 'dark' : 'light'}
				/>
				<JDModal visible={showLiuziBox} transparent={true}>
					<View style={styles.brokerInfoBox}>
						<JDTouchableWithoutFeedback
							contentContainerStyle={styles.liuziBigWindow}
							onPress={()=> {
								this.setState({
									showLiuziBox: false
								})
							}}>
							
						</JDTouchableWithoutFeedback>
						<LiuZiCompon liuziInfo={liuziInfo} close={() => {	this.setState({showLiuziBox: false}) }} propOnConfirm={this.liuziConfirm}></LiuZiCompon>
					</View>
				</JDModal>
				
				{isLoading && <View style={styles.skeletonpageBox}>
						<JDImage
							style={styles.skeletonImg}
							source={skeletonImg}
						></JDImage>
					</View>
				}
				{isErrPage && <View style={styles.errpageBox}>
					<View>
						<JDImage
							style={styles.errpageImg}
							source={errpageImg}
						></JDImage>
					</View>
					<JDText style={styles.errpageText}>当前活动太火爆啦！请稍后重试！</JDText>
					<JDText style={styles.errpageTip}>请点击按钮重新加载</JDText>
					<JDTouchable onPress={this.queryDetailHouseResource}>
						<View style={styles.errpageBtn}>
							<JDText style={styles.errpageBtnText}>重新加载</JDText>
						</View>
					</JDTouchable>
				</View>}
				{isErrorSkuId && <View style={styles.errpageBox}>
					<View>
						<JDImage
							style={styles.errpageImg}
							source={errpageImg}
						></JDImage>
					</View>
					<JDText style={styles.errpageText}>该房源不存在，或已下架</JDText>
				</View>}

				{/*展示大图轮播*/}
				{
					isShowImgPreView && (
						<BigImgSwiper
							imgSwiperData={imgSwiperData}
							currentImgPage={this.state.currentImgPage}
							quitImgPreview={this.quitImgPreview}
						></BigImgSwiper>
					)
				}
				<ScrollView
					style={[isShowImgPreView ? styles.lockScroll : null, (isErrorSkuId || isErrPage ? {'display':'none'} : null )]}
					ref={this.detailsPageScrollView}
					onScroll={this.handleTopOnScroll}		
				>
					{/* {isWeb && <View style={styles.barMeBox}></View>} */}
					<View style={
						(isPhoneX() ? { paddingBottom: pt(150) + 17 } : { paddingBottom: pt(150) })}>
						{
							imgSwiperData &&  imgSwiperData.length > 0 && (
								<ImgSwiper
									imgSwiperData={imgSwiperData || []}
									cityId={1}
									previewAble={true}
									isVR={!!vrUrl}
									pageId={Page_Id}
									skuId={skuId+''}
									isHouseTypeLength={0}
									showVR={showVR}
									isVideo={!!playUrl}
									surfacePlot={surfacePlot}
									playUrl={playUrl}
									changeState={this.changeState}
									enterImgPreview={this.enterImgPreview}
								></ImgSwiper>
							)
						}
						<View style={styles.paddingDiv}>
							{/*楼盘信息模块*/}
							<View style={styles.desInfoWrap}>
								<View style={styles.container}>
									{/* title信息 */}
									<View style={styles.container}>
										<JDText style={styles.desInfoTitle} numberOfLines={2}>{title}</JDText>
									</View>
								</View>
								<View style={styles.desInfoMainWrap}>
									<View style={[styles.desInfoMainWrapCota]}>
										<View style={styles.squareWrapper}>
											<JDText style={styles.desInfoDetailMainValue}>{unitPrice ||  "--"}
											</JDText>
										</View>
										<JDText style={styles.desInfoDetailMainKey}>{HouseType === 'SELL'? '单价（元/m²）':'单价（'+unitTypeMy+'）'}</JDText>
									</View>
									<View style={[styles.desInfoMainWrapCota]}>
										<View style={styles.squareWrapper}>
											<JDText style={styles.desInfoDetailMainValue}>{totalPrice ||  "--"}
											</JDText>
										</View>
										<JDText style={styles.desInfoDetailMainKey}>{HouseType === 'SELL'? '总价（万元）': totalTypeMy}</JDText>
									</View>
									
									<View style={[styles.desInfoMainWrapCota]}>
										<View style={styles.squareWrapper}>
											<JDText style={styles.desInfoDetailMainValue}>{roomArea ||  "--"}
											</JDText>
										</View>
										<JDText style={styles.desInfoDetailMainKey}>面积（m²）</JDText>
									</View>
								</View>

								{/* 户型信息 */}
								<View style={[styles.desInfoDetailWrap, appStyles.alignStart, styles.containRow]}>
									<View style={[styles.containRow, styles.desInfoDetailCota]}>
										<JDText style={styles.desInfoDetailKey}>朝向</JDText>
										<JDText style={styles.desInfoDetailValue}>{orientations || "--"}</JDText>
									</View>
									<View style={[styles.containRow, styles.desInfoDetailCota, styles.desInfoEven]}>
										<JDText style={styles.desInfoDetailKey}>装修</JDText>
										<JDText style={styles.desInfoDetailValue}>{renovation || "--"}</JDText>
									</View>
									<View style={[styles.containRow, styles.desInfoDetailCota]}>
										<JDText style={styles.desInfoDetailKey}>等级</JDText>
										<JDText style={styles.desInfoDetailValue}>{level || "--"}</JDText>
									</View>
									<View style={[styles.containRow, styles.desInfoDetailCota, styles.desInfoEven]}>
										<JDText style={styles.desInfoDetailKey}>楼层</JDText>
										<JDText style={styles.desInfoDetailValue}>{floorType || "--"}</JDText>
									</View>
									<View style={[styles.containRow, styles.desInfoDetailCota]}>
										<JDText style={styles.desInfoDetailKey}>注册情况</JDText>
										<JDText style={styles.desInfoDetailValue}>{registrable === 0 ? '不可注册' : (registrable === 1 ? '可注册' : "--")}</JDText>
									</View>
									{HouseType === 'RENT' && <View style={[styles.containRow, styles.desInfoDetailCota, styles.desInfoEven]}>
										<JDText style={styles.desInfoDetailKey}>分割情况</JDText>
										<JDText style={styles.desInfoDetailValue}>{separable === 0 ? '不可分割' : (separable === 1 ? (separableType === 1 ? '定向分割' : '自由分割') : "--")}</JDText>
									</View>}

									{HouseType === 'RENT' && <View style={[styles.containRow, styles.desInfoDetailCota]}>
										<JDText style={styles.desInfoDetailKey}>租赁形式</JDText>
										<JDText style={styles.desInfoDetailValue}>{rentType || "--"}</JDText>
									</View>}
									{/* {HouseType === 'RENT' && <View style={[styles.containRow, styles.desInfoDetailCota, styles.desInfoEven]}>
										<JDText style={styles.desInfoDetailKey}>可租时间</JDText>
										<JDText style={styles.desInfoDetailValue}>{rentTimeType || "--"}</JDText>
									</View>} */}

									{HouseType === 'SELL' && <View style={[styles.containRow, styles.desInfoDetailCota, styles.desInfoEven]}>
										<JDText style={styles.desInfoDetailKey}>产权人</JDText>
										<JDText style={styles.desInfoDetailValue}>{propertyOwner || "--"}</JDText>
									</View>}

									{HouseType === 'RENT' && <View style={[styles.containRow, styles.desInfoDetailCota, styles.desInfoEven]}>
										<JDText style={styles.desInfoDetailKey}>看房时间</JDText>
										<JDText style={styles.desInfoDetailValue }>{visitType || "--"}</JDText>
									</View>}

									{HouseType === 'RENT' && <View style={[styles.containRow, styles.desInfoDetailCota]}>
										<JDText style={styles.desInfoDetailKey}>付款方式</JDText>
										<JDText style={styles.desInfoDetailValue}>{'押' + pledgeMonth + "付" + payMonth}</JDText>
										</View>}
									{HouseType === 'RENT' && <View style={[styles.containRow, styles.desInfoDetailCota, styles.desInfoEven]}>
										<JDText style={styles.desInfoDetailKey}>免租期</JDText>
										<JDText style={styles.desInfoDetailValue}>{(!!freePeriod && !!freeType) ? freePeriod + freeType : '--' }</JDText>
										</View>}
									{HouseType === 'RENT' && <View style={[styles.containRow, styles.desInfoDetailCota, styles.desInfoDetailFlexOne, { justifyContent: "flex-start" }]}>
										<JDText style={styles.desInfoDetailKey}>租金包含</JDText>
										<JDText style={styles.desInfoDetailValue}>{rentProperties || "--"}</JDText>
									</View>}
									<View style={[styles.containRow, styles.desInfoDetailCota, styles.desInfoDetailFlexOne, { justifyContent: "flex-start" }]}>
										<JDText style={styles.desInfoDetailKey}>楼盘</JDText>
										<JDText style={styles.desInfoDetailValue}>{buildingName ||  "--"}</JDText>
									</View>
									<View style={[styles.containRow, styles.desInfoDetailCota, styles.desInfoDetailFlexOne, { justifyContent: "flex-start" }]}>
										<JDText style={styles.desInfoDetailKey}>地址</JDText>
										<JDText style={[styles.desInfoDetailValue, styles.desInfoDetailTextFlexOne]}>{addressDetail || "--"}</JDText>
									</View>
								</View>
							</View>
							{/* 房源情况*/}
							{
								!!introduction && (
									<View style={styles.moduleBox}>
										<JDImage source={houseBg} style={styles.houseBg} />
										<SubTitle titleName="房源情况" linkDes={''} jump={null}></SubTitle>
										<FlatList
											style={styles.boxMargin}
											data={[{}]}
											renderItem={this.renderHouseDesItem}
											ItemSeparatorComponent={this._separator}
											keyExtractor={(item, index) => 'houseDes_' + index}
										/>
									</View>
								)
							}
							{/* 所属楼盘 */}
							{<View style={styles.moduleBox}>
										<JDImage source={houseBg} style={styles.houseBg} />
										<SubTitle titleName="所属楼盘" linkDes={''} jump={null}></SubTitle>
										<LoupanCard loupanData={commerceBuildingDTO}></LoupanCard>
									</View>
							}
							{/* 专属顾问 */}
							<View style={styles.brokerContainer}>
								<SubTitle titleName="专属顾问" linkDes={''} jump={null} />
								<View style={styles.conItemContainer}>
										<BrokerItem skuid={skuId} brokerInfo={brokerInfo} telPhone={telPhone} extentionPhone={extentionPhone}></BrokerItem>
										<View style={styles.tipsTitleBox}><JDText style={styles.tipsTitleText}>点击直接咨询</JDText>
										<JDImage source={tipsArrow} style={styles.tipsArrow} /></View>
										<View style={styles.tipsAllBox}>
										{
											tipsList.map((item, index) => {
												return <View style={styles.tipsItemBox} key={index+'_tips'}>
												<View style={styles.tipsBgBox}><JDImage source={detailTips} style={styles.tipsBg} /></View>
												<View style={styles.tipsTextBox}><JDText style={styles.tipsText}>{item.text}</JDText></View>
											</View>
											})
										}
										</View>
								</View>
								<JDTouchableWithoutFeedback contentContainerStyle={styles.overlayAbsolute} onPress={this.callPhone} />
							</View>
							<View style={styles.bigShopIconBox}><JDImage source={BigShopImage} style={styles.bigShopIcon} /></View>
						</View>
					</View>
				</ScrollView>
				{/*吸底联系经纪人底部*/}
				{
					<View style={[styles.brokerFooter, isPhoneX() ? { paddingBottom: 27, height: pt(150) + 27 } : '']}>
						<View style={styles.bottomFooter}>
								<JDTouchable style={styles.shopIconBox}
									onPress={this.goShopClick}
								>
										<View style={styles.banner_itemiBox}>
												<View style={styles.banner_itemiconBox}>
														<JDImage style={[styles.banner_itemicon]} source={shopIcon} resizeMode='contain' />
												</View>
												<View style={[styles.itemTextWrap]}>
														<JDText style={styles.banner_itemText}>店铺</JDText>
												</View>
										</View>
								</JDTouchable>
								<JDTouchable style={styles.shopIconBox}
									onPress={this.goLineClick}
								>
									<View style={styles.footerTelBox1}><JDText style={styles.footerLine}>在线咨询</JDText></View>
								</JDTouchable>
								<JDTouchable style={styles.shopIconBox}
									onPress={this.callPhoneFooter}
								>
									<View style={styles.footerTelBox2}><JDText style={styles.footerTel}>电话咨询</JDText></View>
								</JDTouchable>
						</View>
					</View>
				}
				{/*留资浮起层*/}
				{
					!!venderId && (
						<View style={styles.liuziView}>
							<JDTouchable style={styles.liuziBox} key="liuzi"
								onPress={this.handleLiuziIcon}
							>
								<JDImage source={liuziInfo.imgUrl ? { uri: liuziInfo.imgUrl } : liuziIcon} style={styles.liuziIcon} />
							</JDTouchable>
						</View>
					)
				}
				{
					isPhoneX() && (<View style={styles.iphoneXDiv} />)
				}
				{/*错误信息提示模块*/}
				<JDToast show={this.state.isShowErrMsg} onHide={this._onHide} style={styles.toastStyle} mode={JDToast.MODE.MODAL}>
					{this.state.errMsg}
				</JDToast>
			</View>
		)
	}
}

const { height } = Dimensions.get('window');
const styles = StyleSheet.create({
	page: {
		position: 'relative',
		backgroundColor: '#f6f6f6',
		flex: 1,
	},
	navShareView: {
		position: 'absolute',
		top: 0,
		right: 0
	},
	shareIconBox: {
		width: pt(88),
		height: pt(88)
	},
	shareIcon: {
		width: pt(44),
		height: pt(44),
		marginTop: pt(22),
		marginLeft: pt(22),
	},
	lockScroll: {
		overflow: 'hidden'
	},
	barMeBox: {
    width: JDDevice.width,
    height: justLiulanqiHead,
		backgroundColor: '#F6F6F6'
  },
	brokerInfoBox: {
		backgroundColor: 'rgba(0,0,0,.6)',
		position: 'absolute',
		top: 0,
		right: 0,
		bottom: 0,
		left: 0,
		// zIndex: 9999,
	},
	brokerInfoImgClose: {
		width: '100%',
		paddingTop: pt(30),
		height: pt(80),
		flexDirection: 'row',
		justifyContent: 'center',
	},
	imgCloseIcon: {
		width: pt(74),
		height: pt(74),
	},
	brokerInfoCon: {
		height: '100%',
		justifyContent: 'center',
		alignItems: 'center',
		...Platform.select({
			web: {
				height: height
			}
		})
	},
	brokerInfoImg: {
		width: pt(640),
		height: pt(850),
		resizeMode: 'contain'
	},
	container: {
		width: '100%',
	},
	containRow: {
		width: '100%',
		flexDirection: 'row',
		justifyContent: 'space-between'
	},
	// 楼盘信息模块
	desInfoWrap: {
		backgroundColor: '#FFF',
		paddingVertical: pt(36),
		paddingHorizontal: pt(30),
		marginBottom: pt(24),
		marginTop: pt(-84),
		borderRadius: pt(24),
		zIndex: 10
	},
	secondAdvWrap: {
		backgroundColor: '#FFF',
		width: '100%',
		marginBottom: pt(24),
	},
	desInfoPriceWrap: {
		alignItems: "baseline",
		justifyContent: 'flex-start',
		marginTop: pt(4),
	},

	desInfoPrice: {
		marginRight: pt(7),
		color: '#FA2C19',
		fontWeight: 'bold',
		fontSize: pt(42)
	},
	desInfoSqur: {
		color: '#848689',
		fontSize: pt(28),
		...Platform.select({
			android: {
				lineHeight: pt(48)
			}
		})
	},
	desInfoTitle: {
		color: '#1a1a1a',
		fontSize: pt(38),
		fontWeight: 'bold',
		lineHeight: pt(53),
	},
	desInfoLabelWrap: {
		marginTop: pt(30),
	},
	desInfoLabel: {
		color: '#999999',
		fontSize: pt(22),
		paddingHorizontal: pt(10),
		paddingVertical: pt(7),
		borderRadius: pt(4),
		backgroundColor: '#F6F6F6',
		marginRight: pt(12),
	},
	desInfoLabelLight: {
		paddingHorizontal: pt(10),
		paddingVertical: pt(7),
		borderRadius: pt(4),
		marginRight: pt(12),
	},

	desInfoPublishWrap: {
		marginTop: pt(15),
	},
	desInfoPublish: {
		fontSize: pt(28),
		lineHeight: pt(40),
		color: '#848689'
	},
	desInfoDes: {
		backgroundColor: '#E3E5E9',
		width: '100%',
		height: JDDevice.getDpx(1),
		marginTop: pt(28),
		marginBottom: pt(28),
	},
	// 总价，建筑面积，户型
	desInfoMainWrap: {
		flexDirection: 'row',
		marginBottom: pt(48),
		marginTop: pt(30),
		justifyContent: 'space-between'
	},
	desInfoMainWrapCota: {
		width: pt(214),
		justifyContent: 'center',
		alignItems: 'center'
	},
	// 总价
	squareWrapper: {
		flexDirection: 'row'
	},
	// 总价平方
	square: {
		top: pt(0),
		fontSize: pt(22),
		position: 'relative',
		color: '#FA2C19'
	},
	// 单价平方
	squareUnit: {
		top: pt(0),
		fontSize: pt(22),
		position: 'relative',
	},
	desInfoDetailMainValue: {
		fontSize: pt(38),
		fontFamily: 'JDZhengHT-Regular',
		fontWeight: 'normal',
		color: '#FA2C19',
		height:pt(53),
		lineHeight:pt(53)
	},
	wan:{
		fontWeight: 'bold'
	},
	desInfoDetailMainKey: {
		fontSize: pt(24),
		fontFamily: 'PingFang SC',
		fontWeight: 'normal',
		color: '#999999',
		marginTop: pt(10)
	},
	desInfoDetailWrap: {
		flexWrap: 'wrap',
		justifyContent: "space-between"
	},
	desInfoDetailCota: {
		width: '50%',
		marginVertical: pt(8),
		justifyContent: "center"
	},
	desInfoEven: {
		width: pt(300)
	},
	desInfoDetailKey: {
		width: pt(120),
		marginRight: pt(20),
		fontSize: pt(28),
		fontFamily: "PingFang SC",
		fontWeight: 'normal',
		color: '#999999'
	},
	desInfoDetailValue: {
		flex: 1,
		fontSize: pt(28),
		fontFamily: "PingFang SC",
		fontWeight: '500',
		color: '#1A1A1A'
	},
	// 单价
	desInfoDetailPrice:{
		fontSize: pt(28),
		fontFamily: "PingFang SC",
		fontWeight: '500',
		color: '#1A1A1A'
	},
	desInfoDetailFlexOne: {
		width: '100%'
	},
	desInfoDetailTextFlexOne: {
		flex: 1,
	},
	// 地址图标
	houseAddress: {
		width: pt(40),
		height: pt(40),
	},

	desInfoDetailSqurDetailWrap: {
		flexDirection: 'row',
		flex: 1,
		width: '100%',
		marginVertical: pt(10),
	},
	desInfoDetailJumpBtn: {
		width: pt(200),
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'flex-end',
	},
	desInfoDetailJumpBtnText: {
		fontSize: pt(24),
		color: '#555555',
		fontFamily: "PingFang SC",
		fontWeight: 'normal'
	},
	desInfoDetailJumpBtnIcon: {
		width: pt(26),
		height: pt(26),
		marginBottom: pt(3),
	},

	rowLine: {
		width: pt(654),
		marginLeft: 'auto',
		marginRight: 'auto',
		height: JDDevice.getDpx(1),
		backgroundColor: 'rgba(0,0,0,0.08)',
		marginBottom: pt(1)
	}, // 横线的样式

	boxMargin: {
		marginHorizontal: pt(30)
	},
	// 房源情况
	moduleBox: {
		marginBottom: pt(24),
		borderRadius: pt(24),
		backgroundColor: "#fff",
		overflow: 'hidden'
	},
	// 房源背景图
	houseBg: {
		position: 'absolute',
		left: 0,
		top: 0,
		width: '100%',
		height: pt(258)
	},
	// 联系经纪人模块
	brokerContainer: {
		backgroundColor: "#fff",
		marginBottom: pt(24),
		borderRadius: pt(24)
	},
	// 小区及位置周边
	aroundBox: {
		backgroundColor: "#fff",
		marginBottom: pt(24),
		borderRadius: pt(24)
	},
	dataSource: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'center',
		alignItems: 'center',
		height: pt(143),
		backgroundColor: "#fff"
	},
	houseIcon: {
		width: pt(58),
		height: pt(68),
		marginRight: pt(24)
	},
	sourceText: {
		height: pt(34),
		lineHeight: pt(34),
		fontSize: pt(24)
	},
	updateTime: {
		height: pt(30),
		lineHeight: pt(30),
		fontSize: pt(22),
		color: '#aaa'
	},
	// 推荐房源
	houseSourceContainer: {
		backgroundColor: "#fff",
		paddingBottom: pt(12),
		marginBottom: pt(24),
		borderRadius: pt(24)
	},
	toastStyle: {
		backgroundColor: "rgba(0,0,0,0.6)"
	},
	image: {
		width: JDDevice.width,
		height: pt(420),
		resizeMode: 'stretch'
	},
	brokerFooter: {
		position: 'absolute',
		bottom: 0,
		left: 0,
		right: 0,
		zIndex: 2,
		height: pt(150),
		width: pt(750),
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'space-between',
		backgroundColor: '#fff',
		paddingHorizontal: pt(36),
		paddingTop: pt(10),
		paddingBottom: pt(20),
		...Platform.select({ // 不同的平台执行不同的阴影样式
			ios: {
				shadowColor: '#000',
				shadowOffset: { h: 0, w: pt(10) }, // ios设置阴影
				shadowOpacity: 0.05
			},
			web: {
				boxShadow: '0 -3px 10px rgba(0,0,0,0.05)'
			}
		}),
	},
	brokerPic: {
		width: pt(80),
		height: pt(80),
		borderRadius: pt(40),
		borderWidth: JDDevice.getDpx(2),
		borderStyle: 'solid',
		borderColor: '#FA2C19',
		marginRight: pt(26)
	},
	brokerName: {
		fontSize: pt(32),
		fontWeight: 'bold',
		color: '#424854',
		marginBottom: pt(10)
	},
	brokerCompany: {
		fontSize: pt(24),
		color: '#848689'
	},
	footerBg: {
		position: 'absolute',
		bottom: 0,
		left: 0,
		right: 0,
		width: pt(750),
		height: pt(118)
	},
	iphoneXDiv: {
		width: pt(750),
		height: 17,
		backgroundColor: '#F0F2F5'
	},
	paddingDiv: {
		marginHorizontal: pt(24),
	},
	skeletonpageBox:{
		position: 'absolute',
		top: 0,
		right: 0,
		bottom: 0,
		left: 0,
		zIndex: 20000,
		backgroundColor: 'rgba(246,246,246,1)',
		width: '100%',
		overflow:'hidden'
	},
	skeletonImg:{
		width: '100%',
		height:'100%',
	},
	errpageBox: {
		position: 'absolute',
		top: SYS_BAR_HEIGHT,
		right: 0,
		bottom: 0,
		left: 0,
		zIndex: 20000,
		justifyContent: 'center',
		alignItems: 'center',
		backgroundColor: 'rgba(246,246,246,1)',
		width: '100%'
	},
	errpageImg: {
		width: pt(378),
		height: pt(392),
	},
	errpageText: {
		fontSize: pt(32),
		color: '#808080',
		paddingVertical: pt(6),
	},
	errpageTip: {
		fontSize: pt(26),
		color: '#808080',
	},
	errpageBtn: {
		width: pt(200),
		height: pt(88),
		borderRadius: pt(44),
		borderColor: '#FA2C19',
		borderWidth: JDDevice.getDpx(1),
		marginTop: pt(44),
		justifyContent: 'center'
	},
	errpageBtnText: {
		fontSize: pt(34),
		color: '#FA2C19',
		textAlign: 'center'
	},
	houseChangeBox: {
		flexDirection: 'row',
		alignItems: 'center',
		paddingBottom: pt(36),
		paddingLeft: pt(30),
	},
	houseChangeIcon: {
		width: pt(24),
		height: pt(24),
	},
	houseChangeText: {
		fontSize: pt(28),
		color: '#1A1A1A',
		paddingLeft: pt(20),
	},
	houseChangeLine: {
		position: 'absolute',
		top: pt(-32),
		left: pt(40),
		width: pt(3),
		height: pt(30),
		backgroundColor: '#1A1A1A'
	},
	navMiddBox: {
		width: '100%',
		height: pt(88),
		justifyContent: 'center',
		alignItems: 'center'
	},
	navMiddText: {
		fontSize: pt(32),
		color: '#2E2D2D',
	},
	liuziView: {
		width: pt(150),
		height: pt(150),
		position: 'absolute',
		bottom: pt(200),
		right: pt(18),
	},
	liuziBox: {

	},
	liuziIcon: {
		width: pt(150),
		height: pt(150),
	},
	liuziBigWindow: {
		position: 'absolute',
		bottom: 0,
		right: 0,
		width: pt(750),
		height: '100%',
	},



	conItemContainer:{
		paddingHorizontal: pt(28),
		paddingBottom: pt(14)
	},
	tipsTitleBox:{
		flexDirection: 'row',
    justifyContent: 'flex-start',
		alignItems: 'center',
		paddingBottom: pt(24)
	},
	tipsTitleText:{
		color:'#2E2D2D',
		fontSize: pt(26)
	},
	tipsArrow:{
		width: pt(22),
		height: pt(27),
		marginLeft: pt(2)
	},
	tipsAllBox:{
		flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between'
	},
	tipsItemBox:{
		position: 'relative',
		width: pt(309),
		height: pt(60),
		marginBottom: pt(16),
	},
	tipsBgBox:{
		position:'absolute',
		top: 0,
		left: 0,
		width: pt(309),
		height: pt(60)
	},
	tipsBg:{
		width: pt(309),
		height: pt(60)
	},
	tipsTextBox:{
		position:'relative',
		width: pt(309),
		height: pt(60),
		justifyContent: 'center',
		paddingLeft: pt(60)
	},
	tipsText:{
		color:'#642905',
		fontSize: pt(26),
	},
	bigShopIconBox:{
		width: pt(702),
		height: pt(594),
		marginBottom: pt(24),
		borderRadius: pt(24),
		overflow: 'hidden'
	},
	bigShopIcon: {
		width: pt(702),
		height: pt(594),
	},
	bottomFooter:{
		width: '100%',
		flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
	},
	banner_itemiBox: {
		alignItems: 'center',
		justifyContent: 'center',
		paddingHorizontal: pt(30)
},
banner_itemiconBox: {
		width: pt(40),
		height: pt(40),
		marginBottom: pt(8)
},
banner_itemicon: {
		width: pt(40),
		height: pt(40)
},
itemTextWrap: {
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'center'
},

banner_itemText: {
		textAlign: 'center',
		fontSize: pt(20),
		color: '#2E2C2D'
},
	footerTelBox2: {
		flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
		width:pt(264),
		height:pt(84),
		borderRadius: pt(42),
		backgroundColor: '#FA2C19',
	},
	footerTel: {
		color: '#ffffff',
		fontSize: JDDevice.getRpx(32),
		textAlign: 'center',
	},
	footerTelBox1: {
		flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
		width:pt(264),
		height:pt(84),
		borderRadius: pt(42),
		borderWidth: JDDevice.getDpx(2),
		borderStyle: 'solid',
		borderColor: '#FA2C19',
		backgroundColor: '#ffffff',
	},
	footerLine: {
		color: '#FA2C19',
		fontSize: JDDevice.getRpx(32),
		textAlign: 'center',
	},
	overlayAbsolute:{
		position: 'absolute',
		width: '100%',
		height: '100%',
		top: 0,
		flex: 1
	},
})
export default zufangDetail
